import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import FileUpload from '../FileUpload';

interface IProps {
  addResumeVisible: boolean;
  setAddResumeVisible: (visible: boolean) => void;
  onSubmitResume: () => void;
  resumeFile: File|null;
  setResumeFile: (file: File|null) => void;
}

const AddResumeModal: FC<IProps> = ({
  addResumeVisible, setAddResumeVisible, onSubmitResume,
  resumeFile, setResumeFile
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('campus.staff.button1')}
      visible={addResumeVisible}
      onCancel={() => setAddResumeVisible(false)}
      width={400}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmitResume}
          >
            {t('campus.staff.button2')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setAddResumeVisible(false)}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <div>
        <div className="comm-btn__area justify-content-center">
          <FileUpload
            file={resumeFile}
            setFile={setResumeFile}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddResumeModal;
